import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { DifficultSituation } from '../components/DifficultSituation';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { Trajectory } from '../components/Trajectory';
import { MaestroJohn } from '../components/MaestroJohn';
import { LoveGuidance } from '../components/LoveGuidance';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Policies } from '../components/Policies';
import { Footer } from '../components/Footer';
import { MobileActionBar } from '../components/MobileActionBar';
import { useTawkTo } from '../hooks/useTawkTo';
import { useViewportMeta } from '../hooks/useViewportMeta';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';
interface LandingProps {
  lockup: string;
  showTestimonials: boolean;
  freeInitialConsultation: boolean;
}
export function Landing({
  lockup,
  showTestimonials,
  freeInitialConsultation
}: LandingProps) {
  useViewportMeta();
  useGoogleTagManager();
  useTawkTo();
  return <div className="min-h-full w-full bg-carbon font-sans" data-id="element-206" data-mp="3pe82kubhxi3t">
      <Header lockup={lockup} data-id="element-207" data-mp="3pgua4tydzxm1" />
      <main data-id="element-208" data-mp="3kfwtwmwxtdn6">
        <MobileActionBar data-id="element-209" data-mp="3kgexy5pucw5n" />
        <Hero lockup={lockup} data-id="element-210" data-mp="3kgydxgvxlah1" />
        <Intro data-id="element-211" data-mp="3khzshvc5of3i" />
        <DifficultSituation data-id="element-212" data-mp="l0i81y1gmtma" />
        <Services data-id="element-213" data-mp="kzgn91un6srd" />
        <LoveGuidance data-id="element-214" data-mp="l005yks49l6g" />
        {showTestimonials ? <Testimonials data-id="element-215" data-mp="gywojtuf7h34" /> : null}
        <Trajectory data-id="element-216" data-mp="gyofye5byxxq" />
        <MaestroJohn data-id="element-217" data-mp="gzgarmr3srmy" />
        <FinalCTA freeInitialConsultation={freeInitialConsultation} data-id="element-218" data-mp="h112l4m19wh4" />
        <Contact data-id="element-219" data-mp="c6wuuj4y1kez" />
        <Policies data-id="element-220" data-mp="c6dgfcei5e5p" />
      </main>
      <Footer lockup={lockup} data-id="element-221" data-mp="79d78smcvvad" />
    </div>;
}